export default function HeroSection(){

      return(
            <section class="flex flex-col bg#p py-220px justify-center items-center text-white">
                  <p class="w-1007px text-center text-76px font-bold leading-84px text-##E4ECF7 ">Schedule</p>
            </section>
      )

}